import React, { useState } from 'react';
import Login from './components/Login';
import EcardBuilder from './components/EcardBuilder';
import './App.css';

// Pages: 'login' | 'builder'
function App() {
  const [page, setPage] = useState('login');
  const [user, setUser] = useState(null);

  const handleLogin = (userData) => {
    setUser(userData);
    setPage('builder');
  };

  const handleLogout = () => {
    setUser(null);
    setPage('login');
  };

  if (page === 'builder' && user) {
    return <EcardBuilder user={user} onLogout={handleLogout} />;
  }

  return <Login onLogin={handleLogin} />;
}

export default App;
